import React from 'react';
import { motion } from 'framer-motion';

interface TrendItem {
  name: string;
  change: number;
  currentPrice: number;
}

interface TrendCardProps {
  title: string;
  items: TrendItem[];
  icon: React.ReactNode;
  trendColor: string;
}

export const TrendCard: React.FC<TrendCardProps> = ({
  title,
  items,
  icon,
  trendColor
}) => {
  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      className="bg-white rounded-lg shadow-sm p-4"
    >
      <div className="flex items-center gap-2 mb-4">
        {icon}
        <h4 className="font-medium">{title}</h4>
      </div>

      <div className="space-y-3">
        {items.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg"
          >
            <div className="flex-1 min-w-0">
              <p className="font-medium truncate">{item.name}</p>
              <p className="text-sm text-gray-500">
                Precio actual: {item.currentPrice.toFixed(2)}€
              </p>
            </div>
            <span className={`${trendColor} font-semibold`}>
              {item.change > 0 ? '+' : ''}{item.change.toFixed(1)}%
            </span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};